import React from 'react'
import { Button, Menu } from '@sencha/ext-modern'

import { showContextMenu } from './contextmenu'
import { getColumnType } from './column'

import filterTypes, { getFilterItems } from './filterItems'

const genColumnFilter = ({ search, filter, selectValues = [], ...column }) => {
	filter = filter || filter == undefined && search && true

	if (!filter)
		return {}

	const colType = getColumnType(column)

	const ret = {}

	ret.colName = column[colType]
	filter = filter === true && [] || filter

	// column.tools : filter:['type', 'name', options], 均可省略，默认取列项类型定义(去除_)及字段名
	// 20200119 增加类型: 
	while (filter && Array.isArray(filter)) {
		const name = /* filter[1] ||  */column.field || column.name || column[colType]
		name && !ret.colName && (ret.colName = name)

		const typeOfFilter = filter[0] || (colType && colType.slice(1))

		if (filter.length <= 0 && !filterTypes.includes(typeOfFilter))
			break

		if (filter.length > 0 && (!name || !filterTypes.includes(typeOfFilter))) {
			console.error(`column's filter's config error, should be like ['type', 'name', options] : `, columnPar)
			break
		}

		// 'select'
		if (typeOfFilter != 'select' || (Array.isArray(filter[2]) ? filter[2].length/*  > 0  */ : (selectValues[name] && selectValues[name].length/*  > 1 */)))
			ret.filter = { name, type: typeOfFilter, options: filter[2] || selectValues[name] }

		break
	}

	// console.log('ret:', ret)
	return ret
}

const hasFilterValues = (filterProp, name) => filterProp[name] && Object.keys(filterProp[name]).length


// renderFiltersButton(config.filter, config.columns, filterProp, this.handleFilterChange)
// columns.map((column, key) => renderColumn({ filter: config.filter ? [] : undefined, ...column, filterProp, onFilterChange: this.handleFilterChange }, /* `${currTabName || ''}${key}` */key, this))

export const renderFiltersButton = ({ columns, filterProp, filterChoices, onFilterChange, selectValues, ...props } = {}) => {
	const handleFilterClick = (btn, e) => {
		const position = [btn.el.getLeft(), btn.el.getBottom()]
		const menuItems = []
		let itemsCnt = 0

		for (const column of columns) {
			const { colName, filter } = genColumnFilter({ ...column, selectValues })
			if (!colName || !filter)
				continue

			const { items, count } = getFilterItems({ filter, filterProp, filterChoices, onFilterChange, selectValues, isGroup: true })
			itemsCnt += count
			menuItems.push({
				xtype: 'containerfield', margin: '0 20 2 0', flex: 1,
				minWidth: count > 3 && '90%' || 300,
				// maxWidth: /* items.length > 1 && 800 ||  */400,
				layout: { type: 'hbox', wrap: true, align: 'start', pack: 'start' },
				label: colName, labelAlign: 'left', labelTextAlign: 'right',
				ui: hasFilterValues(filterProp, filter.name) ? 'action' : '',
				items
			})
		}

		menuItems.push({
			xtype: 'toolbar', shadow: false, docked: 'bottom', ui: "app-transparent-toolbar", layout: { type: 'hbox', pack: 'right' },
			items: [
				{
					xtype: 'button', text: '确定', /* ui: 'action',  */iconCls: 'x-fa fa-check', style: { padding: '1px 2px 1px 1px' }, margin: '0 20 0 0',
					handler: btn => {
						// console.log('确定:', btn)
						btn.up('menu').close()
					}
				},
				{
					xtype: 'button', text: '清空', /* ui: 'action',  */iconCls: 'x-fa fa-trash-o', style: { padding: '1px 2px 1px 1px' }, margin: '0 20 0 0',
					handler: () => {
						for (let key in filterProp) { delete filterProp[key] }
						for (let key in filterChoices) { delete filterChoices[key] }
						onFilterChange && onFilterChange(filterProp)
						handleFilterClick(btn)
					}
				}
			]
		})

		const menu = [{
			xtype: 'fieldpanel', flex: 1, layout: { type: 'hbox', wrap: true }, margin: '10 0 0 10',
			maxWidth: /* itemsCnt > 20 &&  */800 /* || 400 */,
			items: menuItems
		}]

		showContextMenu(position, menu)
	}

	const haveFilters = !!columns.find(c => {
		const { filter } = genColumnFilter({ ...c, selectValues })
		return !!filter
	})

	if (haveFilters && !filterProp || !onFilterChange) {
		console.error(`filterProp 或 onFilterChange 未设置，不能使用过滤: filterProp:${filterProp}, onFilterChange:${onFilterChange}`)
		return null
	}


	!props.hidden && !haveFilters && (props.hidden = true)
	filterProp && (props.badgeText = Object.keys(filterProp).length)

	return <Button noLocale text='...' iconCls='x-fa fa-filter' shadow margin="0 10 0 0" ui='action' handler={handleFilterClick} {...props} />

	// return <Button text='...' iconCls='x-fa fa-filter' shadow margin="0 20 0 0" ui='action' arrow={false} {...props}>
	//   <Menu autoHide={false} /* scrollable={true} */ maxHeight='90%' /* minWidth='700'  *//* width='800' *//*  maxWidth='800' */
	//     items={menu} layout={{ type: 'vbox' }} />
	// </Button>
}


export const getColumnFilterTool = (columnPar) => {
	const { filterProp, filterChoices, onFilterChange, selectValues } = columnPar
	if (!filterProp || !onFilterChange) {
		// console.error(`filterProp 或 onFilterChange 未设置，不能使用过滤: filterProp:${filterProp}, onFilterChange:${onFilterChange}`)
		return null
	}

	const { filter } = genColumnFilter(columnPar)
	if (!filter)
		return null
	// console.log('filter:', filter)
	// if (!filterProp || !onFilterChange) {
	//   console.error(`filterProp 或 onFilterChange 未设置，不能使用过滤: filterProp:${filterProp}, onFilterChange:${onFilterChange}`)
	//   return null
	// }

	const handleFilterClick = (column, tool, e) => {
		const position = [column.el.getLeft(), column.el.getBottom()]
		const { items, count } = getFilterItems({ filter, filterProp, filterChoices, onFilterChange, selectValues })
		// console.log('items:', filter, items)
		count > 2 && items.push({
			xtype: 'toolbar', shadow: false, docked: 'bottom', ui: "app-transparent-toolbar", layout: { type: 'hbox', pack: 'right' },
			items: [{
				xtype: 'button', text: '清空', /* ui: 'action',  */iconCls: 'x-fa fa-trash-o', style: { padding: '1px 2px 1px 1px' }, margin: '0 20 0 0',
				handler: () => {
					if (!filterProp[filter.name])
						return
					delete filterProp[filter.name]
					delete filterChoices[filter.name]
					onFilterChange && onFilterChange(filterProp)
					handleFilterClick(column)
				}
			}]
		})
		const menu = [{
			xtype: 'fieldpanel', flex: 1, layout: { type: 'hbox', wrap: true }, margin: '10 0 0 10',
			maxWidth: count > 20 && 800 || 400,
			items,
		}]

		showContextMenu(position, menu)
	}


	if (filter)
		return {
			iconCls: 'x-fa fa-filter', zone: 'head',/*  filter,  */
			ui: hasFilterValues(filterProp, filter.name) ? 'action' : '',
			handler: handleFilterClick
		}

	return null
}

